import { Loader, Text } from "@mantine/core";
import { useContext } from "react";
import { useParams } from "react-router-dom";

import { useGetTagById } from "../../../api/tag";
import { AuthContext } from "../../../services/context";
import EditForm from "./Form";
import { useGetEvent } from "../../../api/event";
import {
  getCurrentWorkspace,
  isCurrentEventAdmin,
} from "../../../services/userConfig";

export default function EditSession() {
  const { tagId } = useParams();
  const { user } = useContext(AuthContext);
  const currentWorkspace = getCurrentWorkspace(user);
  const currentEventId = currentWorkspace.eventId;

  const { data: event } = useGetEvent(currentEventId);

  const enableActions = isCurrentEventAdmin(user);
  const {
    data: responseData,
    isPending,
    isError,
    error,
  } = useGetTagById(tagId);

  if (isPending) {
    return <Loader mt={10} />;
  }

  if (isError) {
    return <Text c="red">{error.message}</Text>;
  }

  return (
    <EditForm data={responseData} enableActions={enableActions} event={event} />
  );
}
